export class SecurityGroup {
  allowed_locations;
  clientId;
  description;
  name;
  inactive_session_time_limit;
  allowSeeUserDetails = false;
  menu: {
    menu_item_dash: { description; allowedObjects; allowed: false };
    menu_item_dash_1: { description: ''; allowedObjects: ''; allowed: true };
    menu_item_dash_2: { description: ''; allowedObjects: ''; allowed: true };
    menu_item_dash_reporting: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations: { description: ''; allowedObjects: ''; allowed: true };
    menu_item_locations_activity_map: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations_heatmap: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations_report: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations_store_layout_manager: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations_walking_routes_map: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_locations_zipcodes: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_email: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_facebook: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_google: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_mailchimp: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_paypal: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_paypal_options: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_sms: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_twitter: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_accounts_vouchers: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_analytics_users: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_change_log: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_add_update: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_images_styles: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_lang_locales: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_messaging_strategies: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_dynamic_images: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_image_uploader: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_background_uploader: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_fonts_uploader: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_cp_terms_builder: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_location_groups: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_locations: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_log_journal: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_login_history: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_payment_history: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_replication: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_security_groups: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_vocabularies: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_vocabularies_counties: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_vocabularies_cp_codes: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_organization_wifi_users: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_sessions: { description: ''; allowedObjects: ''; allowed: true };
    menu_item_sessions_active_sessions: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_sessions_radius_log: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_sessions_sessions_stats: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo: { description: ''; allowedObjects: ''; allowed: true };
    menu_item_userinfo_browser_type: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo_demographics: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo_device_types: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo_new_returning: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo_os_type: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_userinfo_unique: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_validation: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_wifi_usage: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_wifi_usage_data_stats: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_wifi_usage_login_method: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
    menu_item_wifi_usage_session: {
      description: '';
      allowedObjects: '';
      allowed: true;
    };
  };
  id;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/security-groups/sec-group.model.ts